import axios, { AxiosResponse } from 'axios';
import { apiClient } from '../apiClient';
import { User } from '../users';
import { Site } from '../sites/sites';
import { DailySubContractor } from '../dailyReports/dailySubContractors';

export interface SubContractor {
    crudStatus: number;
    _id: string;
    designation: string;
    codeProC: string;
    email?: string;
    usageCount?: {
        total: number;
        dailySubContractors: number;
    };
    displayOrder?: number;
    updatedAt?: string;
    createdAt?: string;
}

interface SubContractorsResponse {
    message: string;
    data: SubContractor[];
}

export interface GetAllSubContractorsQueries {
    active?: boolean;
    withUsage?: boolean;
}

export const getAllSubContractors = async (queries?: GetAllSubContractorsQueries): Promise<SubContractorsResponse> => {
    try {
        const response: AxiosResponse<SubContractorsResponse> = await apiClient.get('/subcontractor-types', { params: queries });
        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            throw new Error(error.response.data.message);
        } else {
            throw new Error('An unexpected error occurred');
        }
    }
};

export interface UpdateSubContractorBody {
    designation?: string;
    codeProC?: string;
    color?: string;
    crudStatus?: number;
    email?: string;
    displayOrder?: number | null;
}

export interface SubContractorResponse {
    message: string;
    data: SubContractor;
}

export const updateSubContractor = async (subContractorId: string, data: UpdateSubContractorBody): Promise<SubContractorResponse> => {
    try {
        const response: AxiosResponse<SubContractorResponse> = await apiClient.patch('/subcontractor-types/' + subContractorId, data);
        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            throw new Error(error.response.data.message);
        } else {
            throw new Error('An unexpected error occurred');
        }
    }
};

export interface CreateSubContractorBody {
    designation: string;
    codeProC: string;
    crudStatus?: number;
    email?: string;
    displayOrder?: number | null;
}

export const createSubContractor = async (data: CreateSubContractorBody): Promise<SubContractorResponse> => {
    try {
        const response: AxiosResponse<SubContractorResponse> = await apiClient.post('/subcontractor-types', data);
        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            throw new Error(error.response.data.message);
        } else {
            throw new Error('An unexpected error occurred');
        }
    }
};

export interface MonthlySubContractor extends SubContractor {
    dailySubContractorsByDate: {
        date: string;
        daily: { dailySubContractor: DailySubContractor; user: User; site: Site }[];
    }[];
}

export interface GetMonthlySubContractorParams {
    date: string;
}

export interface MonthlySubContractorsResponse {
    data: MonthlySubContractor[];
    message: string;
}

export const getMonthlySubContractors = async (params: GetMonthlySubContractorParams): Promise<MonthlySubContractorsResponse> => {
    try {
        const response: AxiosResponse<MonthlySubContractorsResponse> = await apiClient.get('/subcontractor-types/monthly/' + params.date);
        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            throw new Error(error.response.data.message);
        } else {
            throw new Error('An unexpected error occurred');
        }
    }
};
